/* eslint-disable @typescript-eslint/no-unused-vars */
import { css } from '@emotion/react'
import { FC, useMemo } from 'react'

const TEXT = {
  applicant: `<p>ご応募ありがとうございます。<br />
コチラの募集へのエントリーを受け付けました。</p>
  <p>今後の連絡はご応募いただいた企業・組織の担当者から後日差しあげます。</p>`,
  repost: `<p>再掲載リクエストありがとうございます。</p>
  <p>再掲載された際はサクサク仕事編集部からご連絡を差しあげます。</p>`,
  register: `<p>ご登録ありがとうございます。</p>
  <p>サクサク仕事編集部から後日ご連絡を差しあげます。</p>`,
} as const

export type Props = {
  type: keyof typeof TEXT
}

const Thanks: FC<Props> = ({ type }) => {
  const bannerSrc = useMemo(() => {
    switch (process.env.APP_ENV) {
      case 'development':
        return 'http://localhost:3000'
      case 'local':
        return 'http://localhost:3000'
      case 'staging':
        return 'https://form-dev.okanechips.com'
      case 'production':
        return 'https://form.okanechips.com'
      default:
        return ''
    }
  }, [])

  return (
    <div>
      <div
        css={{
          color: '#fbe21f',
          fontSize: '2.2rem',
          fontWeight: 'bold',
          lineHeight: '8rem',
          padding: '0 2rem',
        }}
      >
        送信完了しました
      </div>
      <div
        style={{
          padding: '2.4rem 2rem 5rem 2rem',
        }}
      >
        <div
          css={thanksTextStyle}
          dangerouslySetInnerHTML={{
            __html: TEXT[type],
          }}
        />
        <div css={bannerWrapperStyle}>
          <div>
            <div css={bannerTitleStyle}>面接の日程調整ならスケコン</div>
            <div css={bannerStyle}>
              <a href='https://schecon.com/' target='_blank' rel='noreferrer'>
                <img
                  src={`${bannerSrc}/banner_1.jpg`}
                  alt='スケコン'
                  css={{
                    width: '100%',
                  }}
                />
              </a>
            </div>
          </div>
          <div>
            <div css={bannerTitleStyle}>
              入力した情報でスカウト登録にもエントリーしよう!
            </div>
            <div css={bannerStyle}>
              <a
                href='https://worker.mei-kyu.com/worker'
                target='_blank'
                rel='noreferrer'
              >
                <img
                  src={`${bannerSrc}/banner_2.jpg`}
                  alt='スカウト登録'
                  css={{
                    width: '100%',
                  }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Thanks

const thanksTextStyle = () => css`
  color: #fff;
  font-size: 2.5rem;
  margin-bottom: 5rem;
  p: {
    margin-bottom: 5px;
  }
  @media (max-width: 767px) {
    font-size: 1.8rem;
  }
`

const bannerWrapperStyle = () => css`
  display: flex;
  gap: 2rem;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`

const bannerTitleStyle = () => css`
  font-size: 1.6rem;
  font-weight: bold;
  color: #fff;
  display: flex;
  /* align-items: center; */
  gap: 15px;
  margin-bottom: 2rem;
  align-items: stretch;
  &:before {
    content: '';
    display: block;
    width: 0.6rem;
    background: #fbe21f;
    border-radius: 0.3rem;
  }
`

const bannerStyle = () => css``
